import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | Megacoin',
  defaultTitle: 'Megacoin',
  description:
    'The most popular Game Defi platform for everyone, with multi Defi Game support any Tokens on EVMs Blockchain to Play - Win - Earn on a platform you can trust',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@Megacoin',
    site: '@Megacoin',
  },
  openGraph: {
    title: 'MegaCoin - A next evolution Game Defi platform on EVMs Blockchain.',
    description:
      'The most popular Game Defi platform for everyone, with multi Defi Game support any Tokens on EVMs Blockchain to Play - Win - Earn on a platform you can trust',
    images: [{ url: 'https://assets.megacoin.finance/web/og/hero.jpg' }],
  },
}
